export const SCHEDULE_JOB_STATUS = {
  ACTIVE: 'Active',
  DONE: 'Done',
  FAILED: 'Failed',
};
